Monitoring.Views.Dashboards ||= {}

class Monitoring.Views.Dashboards.ChosenTagsView extends Backbone.View
  template: JST["backbone/templates/monitoring/dashboards/chosen_tags"]

  initialize: (@options = {}) ->
  

  render:(tags) ->
    @$el.html(@template())
    return this

  addSelectableTags:(tags, tags_title, allowsMultiple=true)=>
    list = _.map(tags, (tag) -> {code: tag, description: tag, type: 'label'})
    @selectableTagsView = new Customer.Dashboard.SocialContentTagsView({list: list, placeholder: tags_title, allowsMultiple: allowsMultiple})
    @$('#tags-container').append(@selectableTagsView.render().el)

  selectedOptions:()=>
    @selectableTagsView._getCurrentLabels()

  addTags:(tags)=>
    _.each(tags, (tag)=>
        @addTag(tag)
      )

  addTag:(tag)=>
    tag_option_to_delete  = "<option></option>"
    tag_option_to_delete  = $(tag_option_to_delete).html(tag)
    tag_option_to_add = "<option></option>"
    tag_option_to_add = $(tag_option_to_add).html(tag)
    @$('#tags-to-be-deleted').append(tag_option_to_delete)
    @$('#tags-to-be-added').append(tag_option_to_add)

  tagsToBeRemoved:()=>
    @$("#tags-to-be-deleted").chosen().val()

  tagsToBeAdded:()=>
    @$("#tags-to-be-added").chosen().val()

  setOnFinish: (callback) ->
    @onFinish = callback

  onFailure: =>
    document.body.style.cursor = 'default'
    @$el.find("#update, #cancel, #close").prop( "disabled", false )
    @$el.find('#update').addClass('warning').text('Update failed, retry?')
    showError("An unexpected error has occurred. Please contact us if this error persists.")

  resetUpdateButton: ->
    @$el.find('#update').removeClass('warning').text('Update')

  show: ->
    $(@$el).append(@modalElement) if @modalElement
    @modalElement = ''
    @$el.find('#update_all').modal()

  hide: (shouldClearStatus = true) ->
    @$el.find('#update_all').modal('hide')

  delete: ->
    swal({
        title: 'Delete all contents?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonClass: 'btn-danger',
        confirmButtonText: 'Yes, delete',
        closeOnConfirm: true
      }, =>
        @_sendRequest(_.extend(massive: { delete: true }, @searchQuery.attributes))
    )

  create_conversations: ->
    swal({
        title: 'Create conversations for all contents?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonClass: 'btn-danger',
        confirmButtonText: 'Yes, create',
        closeOnConfirm: true
      }, =>
      @_sendRequest(_.extend(massive: { create_conversations: true }, @searchQuery.attributes))
    )

  update: ->
    title = @reached_documents + ' contents will be updated. Are you sure you want to update them?'
    swal({
        title: title,
        type: 'warning',
        showCancelButton: true,
        confirmButtonClass: 'btn-info',
        confirmButtonText: 'Yes, update all',
        closeOnConfirm: true
      }, =>
        massive_tagging = {
          add_tags_all:  _.map(@addTagsView.getTags(), (tag) -> { code: tag }),
          remove_tags_all: _.map(@removeTagsView.getTags(), (tag) -> { code: tag }),
        }
        massive_tagging.sentiment = @$el.find('#sentiment').val() if @$el.find('#sentiment').val() != ''
        massive_tagging.status = @$el.find('#status').val() if @$el.find('#status').val() != ''
        return unless  massive_tagging.add_tags_all or massive_tagging.remove_tags_all
        @_sendRequest(_.extend(massive_tagging: massive_tagging, @searchQuery.attributes))
    )

  cancel: ->
    @hide(false)

  _sendRequest: (params) ->
    updateJob = new Monitoring.Methods.AsyncJob()
    updateJob.bind('completed', @onFinish)
    updateJob.bind('failed', @onFailure)
    updateJob.start 'massive_tagging', params
    @$el.find("#update, #cancel, #close").attr('disabled', 'disabled')
    document.body.style.cursor = 'wait'

  setReachedDocument: (documents_count) ->
    @reached_documents = documents_count
